import { template } from 'lodash';
import { translations } from './translations';
const UNKNOWN_MESSAGE = 'UNKNOWN_MESSAGE';
const settings = {
  interpolate: /{([\s\S]+?)}/g
};
const templates = {};
const returnTranslationKey = descriptor => {
  if (typeof descriptor === 'string') {
    return descriptor;
  }
  return descriptor.id;
};
const translate = (descriptor, values) => {
  const {
    id,
    defaultMessage
  } = typeof descriptor === 'object' ? descriptor : {
    id: descriptor,
    defaultMessage: UNKNOWN_MESSAGE
  };
  const templateString = translations.get(id) || defaultMessage;
  templates[templateString] = templates[templateString] || template(templateString, settings);
  const templateFn = templates[templateString];
  return templateFn(values);
};
const t = typeof window !== 'undefined' && /showTranslationKeys/.test(window.location) ? returnTranslationKey : translate;
export const i18n = {
  t
};
//# sourceMappingURL=i18n.js.map